import PaystackPop from "@paystack/inline-js";

// Opens the Paystack Inline popup for an already-initialized transaction (access_code).
// The transaction is created on the backend at the click that produced `init`, and the
// popup only opens here — never on mount. Falls back to a full redirect if no access_code
// (e.g. mock mode) is available.
export function openPaystackPopup(init, { onSuccess, onCancel } = {}) {
  if (!init || !init.access_code) {
    if (init && init.authorization_url) window.location.href = init.authorization_url;
    return;
  }
  const popup = new PaystackPop();
  popup.resumeTransaction(init.access_code, {
    onSuccess: (tx) => onSuccess && onSuccess(tx),
    onCancel: () => onCancel && onCancel(),
    onError: () => onCancel && onCancel(),
  });
}
